import { useQuery } from '@tanstack/react-query';
import { apiFetch } from '../lib/api-client.js';
import { useAuth } from '../store/auth.js';

interface WalletResponse { balance: number; giftJustGranted: boolean; firstTopupBonus?: number }

export function useStarWallet(): { balance: number; firstTopupBonus: number; isLoading: boolean } {
  const jwt = useAuth((s) => s.jwt);
  const q = useQuery<WalletResponse, Error>({
    queryKey: ['star-wallet'],
    queryFn: async () => {
      if (!jwt) throw new Error('not_authenticated');
      const res = await apiFetch('/api/v1/stars/wallet', jwt);
      if (!res.ok) throw new Error(`wallet_failed_${res.status}`);
      return (await res.json()) as WalletResponse;
    },
    enabled: !!jwt,
    staleTime: 10_000,
  });
  return { balance: q.data?.balance ?? 0, firstTopupBonus: q.data?.firstTopupBonus ?? 0, isLoading: q.isLoading };
}
